import {
  MAutocomplete,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import {
  useAnalysisTypes,
  useInstallation,
  useIsotopos,
  useTypeSample,
} from "@services/servicesGenericsTables";
import React from "react";
import { useFormContext } from "react-hook-form";

const OperacionalForm = () => {
  const { getValues } = useFormContext();
  const { installationList } = useInstallation();
  const { isotoposList } = useIsotopos();
  const { sampleTypeList } = useTypeSample();
  const { analysisTypeList } = useAnalysisTypes();

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MAutocomplete
          key={JSON.stringify(getValues("instalacion"))}
          name="instalacion"
          options={installationList}
          label="Instalación"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}`
          }
          validation={{ required: "La instalación es requerida" }}
        />
        <MAutocomplete
          key={JSON.stringify(getValues("isotopo"))}
          name="isotopo"
          options={isotoposList}
          label="Isotopo"
          getOptionLabel={(option) => `${option.codigo}`}
          validation={{ required: "El código es requerido" }}
        />
        <MAutocomplete
          key={JSON.stringify(getValues("tipomuestra"))}
          name="tipomuestra"
          options={sampleTypeList}
          label="Tipo de Muestra"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}`
          }
          validation={{ required: "El tipo de muestra es requerido" }}
        />
        <MAutocomplete
          name="analisis"
          options={analysisTypeList}
          label="Análisis"
          getOptionLabel={(option) => option.descripcion}
          validation={{ required: "El analysis es requerida" }}
        />
        <MTextField
          key={"actividad"}
          name={"actividad"}
          label={"Actividad"}
          type="text"
          fullWidth
          validation={{ required: `El campo actividad es requerido` }}
        />
        <MTextField
          key={"lid"}
          name={"lid"}
          label={"Lid"}
          type="text"
          fullWidth
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default OperacionalForm;
